const SECTIONS_TEACHING_JOBS_PAGE = ['why', 'how', 'teaching', 'allCourseTeaching', 'news', 'join', 'faq'];
const SECTIONS_TEACHERS_FOR_HIRE_PAGE = ['why', 'how', 'free', 'faq'];

const getBullets = (content, prefix) => {
  let b = {};

  for (let k in content) {
    if (k.startsWith(prefix)) {
      b[k] = content[k];
    }
  }

  return b;
}

const getSectionsByPage = (state, subject, page) => {
  switch (page) {
    case 'OnlineTeachingJobsPage':
      // return sectionsByPage(SECTIONS_TEACHING_JOBS_PAGE, state, subject);
      return SECTIONS_TEACHING_JOBS_PAGE;

    case 'OnlineTeachersForHirePage':
      // return sectionsByPage(SECTIONS_TEACHERS_FOR_HIRE_PAGE, state, subject);
      return SECTIONS_TEACHERS_FOR_HIRE_PAGE;

    default:
      return {};
  }
}

const sectionsByPage = (page, state, subject) => {
  let sections = {};
  page.forEach(i => sections[i] = state && subject ? `${i}-${state}-${subject}` : state ? `${i}-${state}` : i);
  return sections;
}

module.exports = {
  getBullets,
  getSectionsByPage,
}
